var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1C400;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,1.5C23.5,1.5,2,23,2,49.5s21.5,48,48,48s48-21.5,48-48S76.5,1.5,50,1.5z M56,84H44V72h12V84z M59.2,56.4 c-2.1,1.2-3.3,3.4-3.2,5.8V63H44v-0.8c-0.1-7,3.7-13.4,9.9-16.6c3.1-1.5,5.1-4.7,5.1-8.1c-0.1-4.9-4.1-8.9-9-9c-5,0-9,4-9,9H29 c0-11.6,9.4-21,21-21c11.5,0.2,20.8,9.5,21,21C71,45.5,66.4,52.9,59.2,56.4z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question_icon.3df1d324.svg";
export { ForwardRef as ReactComponent };